// extracted by mini-css-extract-plugin
export default {"hideTooltip":"f9-z","fadeIn":"g9-z","delay":"h9-z","recommendedSizeTooltip":"i9-z"};